import { render, staticRenderFns } from "./default.vue?vue&type=template&id=8945fe54&scoped=true&"
import script from "./default.vue?vue&type=script&lang=ts&"
export * from "./default.vue?vue&type=script&lang=ts&"
import style0 from "./default.vue?vue&type=style&index=0&id=8945fe54&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8945fe54",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Loading: require('/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/components/Loading/index.vue').default,TopBar: require('/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/components/TopBar/index.vue').default,DownLoadModal: require('/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/components/DownLoadModal/index.vue').default})
